// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2qCDO","label":"Category_label__3KZk3","content":"Category_content__35FGH","header":"Category_header__2VEnd","location":"Category_location__3Umey"};